export const returnJobDetailsSidebarText = {
	title: 'Return jobs',
	sectionLabelSelected: 'Return job selected:',
	sectionLabelOther: 'Other jobs available:',
	noReturnJobsFound: 'No return jobs found.',
};
